// this function will sort elements (param) by their name alphabetically 
// and ignore the words "The", "A", or "An" at the beginning of the name. 
// It will also ignore case sensitivity.
export const sortElementsNoThe = (elements) => {
    return elements.sort((a, b) => {
        const nameA = a.name ? a.name.toUpperCase().replace(/^(THE|A|AN)\s/, '') : a.fName.toUpperCase().replace(/^(THE|A|AN)\s/, '');
        const nameB = b.name ? b.name.toUpperCase().replace(/^(THE|A|AN)\s/, '') : b.fName.toUpperCase().replace(/^(THE|A|AN)\s/, '');
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    });
}